<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><span class="sz"> </span></p>
<p class="p3"><span class="sz"> </span></p>
<p class="p4"><span class="sz"><i>For Simon Brown,</i></span></p>
<p class="p4"><span class="sz"><i>fellow boggler.</i></span></p>
<p class="p5"><span class="sz"><b></b> </span></p>
<p class="p5"><span class="sz"><b></b> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?d72310a0